// removed by extract-text-webpack-plugin
module.exports = {"container":"_3ed8lfLGr_Qk6wN0pKM_zr","form":"_3CJAqYoNx_zxF2m66lY8nX","field":"_32fyy8Q8P8rinERISVmgHs","icon":"_38trbbbGrL14nn7HXoWyjB","title":"_1pZrn-USS0qEp8ZdhHTCJ4"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Preparation/DocumentInformation/UpdateForm/styles.css
// module id = 3271
// module chunks = 0